import { render, staticRenderFns } from "./PolicyPrivacy.vue?vue&type=template&id=11c2a2e1&scoped=true"
import script from "./PolicyPrivacy.vue?vue&type=script&lang=js"
export * from "./PolicyPrivacy.vue?vue&type=script&lang=js"
import style0 from "./PolicyPrivacy.vue?vue&type=style&index=0&id=11c2a2e1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c2a2e1",
  null
  
)

export default component.exports